import * as React from "react";
import { memo } from "react";
const SvgCreateAdd = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M11.143.857H8.857v6.857h2.286V.857Zm1.143 10.286h6.857V8.857h-6.857v2.286ZM.857 8.857v2.286h8v8h2.286V10L10 8.857H.857Z", fill: "currentColor" }));
const Memo = memo(SvgCreateAdd);
export default Memo;
